import { useToast } from "@/hooks/use-toast";
import { useAppDispatch } from "@/store";
import {
  AppRegionEnum,
  selectAppRegion,
  setRegion,
} from "@/store/appConfigSlice";
import { Box, Switch, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";

const RegionSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      "& .MuiSwitch-thumb": {
        backgroundColor: "#FFFFFF",
        backgroundImage: `linear-gradient(180deg, #F00 25%, transparent 25%, transparent 50%, #F00 50%, #F00 75%, transparent 75%, #fff)`,
      },
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#D80621",
    borderRadius: 20 / 2,
    ...theme.applyStyles("dark", {
      backgroundColor: "#D80621",
    }),
  },
}));

const RegionToggle = () => {
  const region = useSelector(selectAppRegion);
  const dispatch = useAppDispatch();
  const { toast } = useToast();

  const handleRegionChange = () => {
    const newRegion =
      region === AppRegionEnum.CA ? AppRegionEnum.US : AppRegionEnum.CA;
    dispatch(setRegion(newRegion));
    toast({
      title: `Region changed to ${newRegion === AppRegionEnum.CA ? "🇨🇦 Canada" : "🇺🇸 United States"}.`,
      description: (
        <>
          {newRegion === AppRegionEnum.CA ? (
            <>
              <Typography variant="caption">
                Temporary data limitations may apply in Canada until full data
                integration is complete.
              </Typography>
              <br />
              <Typography variant="caption">
                Similar properties in generated assessments MAY not pull
                expected listings and{" "}
                <Typography color="red" component={"span"} variant="caption">
                  assessments will not be re-evaluated nightly.
                </Typography>
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="caption">
                Temporary data limitations may apply in USA until full data
                integration is complete.
              </Typography>
              <br />
              <Typography variant="caption">
                Similar properties in generated assessments MAY not pull
                expected listings;{" "}
                <Typography color="green" component={"span"} variant="caption">
                  however, assessments will be re-evaluated nightly.
                </Typography>
              </Typography>
            </>
          )}
        </>
      ),
      itemID: "region-change-notice",
    });
  };
  return (
    <Box mx={"auto"} display={"flex"} alignItems="center" px={1}>
      <Typography variant="body2">🇨🇦</Typography>
      <RegionSwitch
        aria-label="RegionSelector"
        checked={region !== AppRegionEnum.CA}
        onClick={handleRegionChange}
      />
      <Typography variant="body2">🇺🇸</Typography>
    </Box>
  );
};

export default RegionToggle;
